import { render, staticRenderFns } from "./AgentPair.vue?vue&type=template&id=6080d90a&scoped=true&"
import script from "./AgentPair.vue?vue&type=script&lang=js&"
export * from "./AgentPair.vue?vue&type=script&lang=js&"
import style0 from "./AgentPair.vue?vue&type=style&index=0&id=6080d90a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6080d90a",
  null
  
)

export default component.exports